import React from "react";
import "./counter.css";
import { useAppContext } from "../../AppContext";
import { formatAsEuro } from "../../helpers/helpers";
import { ProductTypes, CartItem } from "../../file.interface";

const Counter: React.FC<{
  product: CartItem;
  flow: CartItem[];
}> = ({ product, flow }) => {
  //
  const count = flow.filter((d) => d.id === product.id).length;

  const { dispatch, selectedContractDuration } = useAppContext();

  const decrese = () => {
    if (count >= 1) {
      const itemIndex = flow.findIndex(
        (accProduct) => accProduct.id === product.id
      );
      if (itemIndex !== -1) {
        let alreadyRemoved = false;
        let newFlow = flow.filter((device) => {
          if (device.id === product.id && !alreadyRemoved) {
            alreadyRemoved = true;
            return false;
          }
          return true;
        });
        const key = getKey(product);
        dispatch({
          type: "UPDATE_CONTEXT",
          payload: {
            [key]: newFlow,
          },
        });
      }
    }
  };

  const increse = () => {
    if (count < 10) {
      const key = getKey(product);
      dispatch({
        type: "UPDATE_CONTEXT",
        payload: {
          [key]: flow.concat(product),
        },
      });
    }
  };

  return (
    <div className="counter-container">
      <div onClick={decrese} className="counter-button">
        -
      </div>
      <div className="counter">{count}</div>
      <div onClick={increse} className="counter-button">
        +
      </div>
      <div>
        {formatAsEuro(product.prices[selectedContractDuration] * count)}
      </div>
    </div>
  );
};

export const getKey = (selectedProduct: CartItem) => {
  if (selectedProduct.type === ProductTypes.Epos) {
    return "flowDevices";
  }
  if (selectedProduct.type === ProductTypes.Terminals) {
    return "flowCardMachines";
  }
  return "flowAccessories";
};

export default Counter;
